import {ref} from 'vue';
import {UserData} from '@/unlogged/types/custom';

export interface UserDataFetch {
    isLoading: boolean;
    data: UserData | null;
}

const logger = console;

export const useUserData = () => {
    const userState = ref<UserDataFetch>();
    try {
        fetch('/api/user')
            .then((response) => response.json())
            .then((data) => {
                userState.value = {isLoading: false, data};
            });
    } catch (error) {
        logger.error(error);
        userState.value = {
            isLoading: false,
            data: {
                info: null,
                isLoggedIn: false,
            },
        };
    }

    return userState;
};
